export default function isDict(variable: any): boolean {
    return typeof variable === "object" &&
        variable !== null &&
        !Array.isArray(variable)
        // && Object.prototype.toString.call(variable) === "[object Object]"
}